import React, { useCallback } from 'react'
import classNames from 'classnames'

import { DriverNode } from '@/apollo/graphql'
import { IDriver } from '@/types'

import { useData } from '../useData'
import DriverForm from './form'

interface IEditDriver {
  visible: boolean
  node?: Partial<DriverNode>
  onClose: () => void
}

const EditDriver: React.FC<IEditDriver> = ({ visible, onClose, node }) => {
  const { loading, submitting, onSubmit } = useData({ id: node?.id })

  const onSubmitForm = useCallback(
    (d: IDriver) => {
      onSubmit(
        `cars/drivers/${node?.id}/`,
        true,
        onClose,
      )({
        driver: d,
        driver_id: node?.id,
      })
    },
    [node?.id, onClose, onSubmit],
  )

  return (
    <div
      className={classNames('info-box mobile-modal scroll-sticky w-100', {
        open: visible,
      })}
    >
      <DriverForm
        loading={loading}
        isEditing={visible}
        initialData={node}
        onCancel={onClose}
        submitting={submitting}
        onSubmit={onSubmitForm}
      />
    </div>
  )
}

export default EditDriver
